import { IPaginatedData, IPaginatorParams } from '@/types/genericDataTable';
import { TicketStore } from '../stores/ticket-store-map';
import { ITicket, ITicketFilter } from '@/types/ticket';

export const TICKET_PATH = '/tickets_v2';
export const ROOT_URL = TICKET_PATH;

export const TICKET_LIST_TABS: TicketStore['tabActive'][] = [
    'my_tickets',
    'my_groups',
    'my_history',
];
export const TICKET_LIST_TABS_LABELS: Record<TicketStore['tabActive'], string> =
    {
        my_tickets: 'Mis tickets',
        my_groups: 'Mis grupos',
        my_history: 'Histórico',
    };
export const DEFAULT_TICKET_LIST_TAB_ACTIVE: TicketStore['tabActive'] =
    'my_tickets';

export const DEFAULT_PAGINATOR: IPaginatorParams = {
    limit: 20,
    page: 1,
};

export const DEFAULT_PAGINATOR_OUT: IPaginatedData<ITicket> = {
    currentPage: 1,
    items: [],
    limit: 20,
    total: 0,
    totalPages: 1,
};

export const BASE_TAB_FILTER: Record<
    TicketStore['tabActive'],
    Partial<ITicketFilter>
> = {
    my_tickets: {
        status: 'open,solved,onhold_client,onhold_user,onhold_third_parties',
    },
    my_groups: {
        status: 'open,solved,onhold_client,onhold_user,onhold_third_parties',
    },
    my_history: {
        status: 'open,solved,onhold_client,onhold_user,onhold_third_parties,closed',
    },
};

export const RELATED_EVENTS = ['user_status_updated', 'ticket_tags_change', 'ticket_without_assigment'];
